import TenantPage from 'layouts/TenantPage';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { productService } from 'shared/services';
import { loadingActions } from 'store';
import { useAppDispatch } from 'store/store';
import toast from 'shared/utils/toast';
import { ProductForm } from '../components/form/ProductForm';
import { IProduct } from '../types';

const initProduct: IProduct = {
  id: null,
  code: null,
  description: '',
  commercial_name: '',
  type: null,
  category: null,
  status: null,
  uom: '',
  packaging: '',
  units_per_package: 1
};

export const CreateProduct = () => {
  const { t } = useTranslation();
  const translationPrefix = 'pages.product.new';

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const onSubmit = async (values) => {
    dispatch(loadingActions.startLoading());
    productService.add(values).then((res) => {
      if (res?.id) {
        toast.crud.successCreate('Prodotto');
        navigate(`../${res.id}`);
      }
    });
    dispatch(loadingActions.stopLoading());
  };

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}>
      <ProductForm product={initProduct} onSubmit={onSubmit} />
    </TenantPage>
  );
};

export default CreateProduct;
